<template>
  <!-- 파트너스 레이아웃 (사이드바 분리) -->
  <div v-if="isPartnersRoute" class="partners-app">
    <PartnersSideBar />
    <div class="partners-main">
      <router-view />
    </div>
    <PartnersChatFloat />
  </div>

  <!-- 어드민 레이아웃 -->
  <template v-else-if="isAdminRoute">
    <router-view />
  </template>

  <!-- 일반 레이아웃 -->
  <template v-else>
    <!-- 데스크탑: 상단 헤더 -->
    <MainHeader v-if="showMainHeader" class="desktop-header" />
    <router-view />
    <!-- 모바일: 하단 탭바 -->
    <MobileTabBar v-if="showMobileTabBar" />
  </template>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import PartnersSideBar from '@/components/partners/common/PartnersSidebar.vue'
import PartnersChatFloat from '@/components/partners/chat/PartnersChatFloat.vue'
import MainHeader from '@/components/common/MainHeader.vue'
import MobileTabBar from '@/components/common/MobileTabBar.vue'

export default {
  name: 'App',
  components: {
    PartnersSideBar,
    PartnersChatFloat,
    MainHeader,
    MobileTabBar
  },
  setup() {
    const route = useRoute()

    // 파트너스 경로인지 확인
    const isPartnersRoute = computed(() => {
      const path = route.path
      // 로그인/상태/인트로 페이지는 제외
      if (path === '/partners/login' || path === '/partners/register' || path === '/partners/status' || path === '/partners/intro') {
        return false
      }
      return path.startsWith('/partners')
    })

    // 어드민 경로인지 확인
    const isAdminRoute = computed(() => {
      return route.path.startsWith('/admin')
    })

    // 메인 헤더 표시 여부 (데스크탑용)
    const showMainHeader = computed(() => {
      const path = route.path
      // 로그인 페이지에서만 숨김
      if (path === '/login') {
        return false
      }
      return true
    })

    // 모바일 탭바 표시 여부
    const showMobileTabBar = computed(() => {
      const path = route.path
      // 로그인 페이지에서만 숨김
      if (path === '/login') {
        return false
      }
      return true
    })

    return {
      isPartnersRoute,
      isAdminRoute,
      showMainHeader,
      showMobileTabBar
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.partners-app {
  display: flex;
  height: 100vh;
  height: 100dvh;
  background-color: #f8fafc;
  overflow: hidden;
}

.partners-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  min-width: 0;
}

/* 데스크탑 헤더는 모바일에서 숨김 */
@media (max-width: 1024px) {
  .desktop-header {
    display: none;
  }
}

/* 모바일에서 하단 탭바 여백 */
@media (max-width: 1024px) {
  #app {
    padding-bottom: 64px;
  }
}
</style>
